export const validateUrl = (url: string) => {
	if (!/^https?:\/\//i.test(url)) {
		url = 'https://' + url;
	}
	return url;
};
